export enum TimePeriod {
  AM = 'AM',
  PM = 'PM',
}

type ParseTimeResult =
  | {
      isValid: false;
    }
  | {
      isValid: true;
      hours: number;
      minutes: number;
    };

const invalidParseTimeResult: ParseTimeResult = { isValid: false };

export const isValidPartialTimeValue = (text: string | undefined): boolean =>
  !text ||
  text.length === 0 ||
  (
    text?.match(
      /^(0(?:[1-9]|$)|1(?:[0-2]|$))(?:(:)(?:([0-5])(?:([0-9])?)?)?)?$/,
    ) ?? []
  ).length > 0;

export const formatTimeFromDate = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, '0');
  const hours = [date.getHours() % 12].map(x => (x === 0 ? 12 : x))[0];
  const minutes = date.getMinutes();
  return `${pad(hours)}:${pad(minutes)}`;
};

export const parseTime = (input: string | undefined): ParseTimeResult => {
  const match = /(\d{2}):(\d{2})/.exec(input ?? '');

  if (!match) return invalidParseTimeResult;

  const [_, ...groups] = match;
  const [hours, minutes] = groups.map(Number);

  if (hours < 1 || hours > 12 || minutes < 0 || minutes > 59)
    return invalidParseTimeResult;

  return {
    isValid: true,
    hours,
    minutes,
  };
};

export function assertValidTime(
  result: ParseTimeResult,
): asserts result is { isValid: true; hours: number; minutes: number } {
  if (!result.isValid) throw new Error('Unexpected invalid time result');
}

export const validateTime = (raw: string | undefined) => parseTime(raw).isValid;

export const parseDateTime = (date: Date, time: string, period: TimePeriod) => {
  const timeResult = parseTime(time);
  assertValidTime(timeResult);

  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    (timeResult.hours % 12) + (period === TimePeriod.PM ? 12 : 0),
    timeResult.minutes,
  );
};
